<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card v-on:keyup.enter="buildNewSearch">
		<v-card-title>
			<h3>Oceny przebiegu współpracy</h3>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-layout align-center justify-center row>
			<v-flex xs3>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="searchedFields.projectCode"
					label="Nr projektu"
					aria-label="project code"
					for="bidder-evaluation-list-project-code"
					id="bidder-evaluation-list-project-code"
				></v-text-field>
			</v-flex>
			<v-flex xs3>
				<v-select
					class="ma-2"
					v-model="searchedFields.realizationYear"
					label="Rok realizacji"
					aria-label="realization year"
					for="bidder-evaluation-project-code"
					id="bidder-evaluation-project-code"
					:items="selectItems.realizationYears"
				></v-select>
			</v-flex>
			<v-flex xs3>
				<v-autocomplete
					class="ma-2"
					v-model="searchedFields.accreditationCountry"
					label="Kraj"
					for="bidder-evaluation-accreditation-country"
					id="bidder-evaluation-accreditation-country"
					:items="selectItems.accreditationCountries"
					aria-label="accreditation country"
					item-text="name"
					item-value="id"
				></v-autocomplete>
			</v-flex>
		</v-layout>
		<v-layout align-center justify-center row>
			<v-spacer/>
			<v-flex xs4>
				<v-layout align-center justify-center>
					<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="headers"
			:rows-per-page-items="[10,20,25]"
			:items="evaluations"
			:pagination.sync="pagination"
			:total-items="itemCount"
			class="elevation-1">
			<template v-slot:items="props">
				<tr :class="{ 'primary--text': props.item.mutualProject }">
					<td>{{ props.item.evaluationDate }}</td>
					<td>{{ props.item.projectCode }}</td>
					<td>{{ props.item.projectName }}</td>
					<td>{{ props.item.realizationYear}}</td>
					<td>{{ props.item.accreditationCountry}}</td>
					<td>{{ props.item.evaluation}}</td>
					<td align="center">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon @click="goToReportPanel(props.item)">
									<v-icon v-on="on">
										description
									</v-icon>
								</v-btn>
							</template>
							<span>Podgląd</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon @click="showArrears(props.item.projectId)">
									<v-icon v-on="on" :color="getArrearsColor(props.item)">
										account_balance_wallet
									</v-icon>
								</v-btn>
							</template>
							<span>{{getArrearsTitle(props.item)}}</span>
						</v-tooltip>
					</td>
				</tr>
			</template>
		</v-data-table>

		<ProjectArrearsView
			:is-open.sync="showArrearsData"
			:arrears-data="arrearsData"/>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {Pagination} from "@/utils/PaginationUtils";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {ContestRealizationYear} from "@/api/generated/ContestRealizationYear";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";
	import {Project} from "@/api/generated/Project";
	import ProjectArrearsView from "../project/ProjectArrearsView";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "BidderEvaluationList",
		components: {ProjectArrearsView},

    mixins: [Filters],

		data () {
			return {
				headers: [
					{text: "Data oceny", value: "evaluationDate", sortable: true},
					{text: "Numer projektu", value: "projectCode", sortable: true},
					{text: "Nazwa projektu", value: "projectName", sortable: true},
					{text: "Rok realizacji", value: "realizationYear", sortable: true},
					{text: "Kraj", value: "accreditationCountry", sortable: false},
					{text: "Ocena", value: "evaluation", sortable: true},
					{text: "Akcje", value: "actions", sortable: false},
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
				},
				search: "",
				searchedFields: Pagination.initSearchedFields([
					'bidderId',
					'projectCode',
					'realizationYear',
					'accreditationCountry'
				]),
				evaluations: [],
				selectItems: {
					realizationYears: [],
					accreditationCountries: []
				},
				showArrearsData: false,
				arrearsData: null,
				userId: null,
			};
		},

		created () {
			this.loadRealizationYears();
			this.loadAccreditationCountries();
      this.searchedFields = this.retrieveFilters(this.searchedFields);
      this.pagination = this.retrievePagination(this.pagination);
		},

		watch: {
			"pagination": {
				handler (pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},
		},

		computed: {
			userBidderId() {
				return this.onlyMine ? this.userId : this.$route.params.bidderId;
			}
		},

		methods: {
			buildNewSearch () {
				this.search = this.buildSearchCriteria();
				this.getItemList();
			},

			buildSearchCriteria () {
				this.searchedFields.bidderId = this.$route.params.bidderId;
				return Pagination.buildSearchCriteria(this.searchedFields, true);
			},

			buildSort () {
				let order = this.pagination.descending ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			exportData () {
				let search = this.search;
				let sort = this.buildSort();
				let path = "/bidder-evaluation/export?search=" + search + "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList () {
				if (this.search === "") {
					this.search = this.buildSearchCriteria();
				}
				let sort = this.buildSort();
				Api.get(this,
					"/bidder-evaluation/list?search=" + this.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.evaluations = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			resetSearch () {
				Pagination.resetSearch(this.searchedFields);
				this.search = "";
				this.getItemList();
			},

      getArrearsColor (evaluation) {
        if (!evaluation.assignedToArrears) {
          return "green darken-1";
        }
				switch (evaluation.projectArrearsStatus) {
					case "NONE":
						return "green darken-1";
					case "NOT_PAID":
						return "lightred";
					default:
						return "success";
				}
			},

			getArrearsTitle (evaluation) {
        if (!evaluation.assignedToArrears) {
          return "Brak zaległych płatności";
        }
        switch (evaluation.projectArrearsStatus) {
					case "NONE":
						return "Brak zaległych płatności";
					case "NOT_PAID":
						return "Zaległe płatności";
					default:
						return "Zaległe płatności uregulowane";
				}
			},

			goToReportPanel (item) {
				this.$router.push("/app/" + item.contestId + "/" + item.projectId + "/evaluation-form/" + item.evaluationId);
			},

			showArrears (projectId) {
				Project.getArrears(this, projectId, successResponse => {
						this.arrearsData = successResponse;
						this.showArrearsData = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować zaległości projektu", errorResponse);
					});
			},

			loadRealizationYears () {
				ContestRealizationYear.getList(this,
					successResponse => {
						this.selectItems.realizationYears = successResponse.items.map(x => x.value).sort((a, b) => a - b);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się wczytać lat realizacji", errorResponse);
					});
			},

			loadAccreditationCountries () {
				AccreditationCountry.getListAll(this,
					successResponse => {
						this.selectItems.accreditationCountries = successResponse.sort((a, b) => a.name.localeCompare(b.name));
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się wczytac krajów przeznaczenia", errorResponse);
					});
			},
		},
	};
</script>

<style scoped>

</style>

